import { Link } from "react-router-dom";
import Reveal from "@/components/site/Reveal";
import { JOIN } from "@/constants/testIds";
import { JOIN_PROGRAMS } from "./joinData";

export default function OfferSection() {
  return (
    <section
      data-testid={JOIN.programs}
      className="section-pad"
      style={{ background: "#ffffff" }}
    >
      <div className="container-wide">
        <Reveal className="max-w-2xl mb-14">
          <div className="eyebrow mb-5">What you&apos;ll offer</div>
          <h2 className="type-section-heading mb-4">
            Four high-value programs your clients will love.
          </h2>
          <p className="type-body-large">
            As a SmartEdge agent, you&apos;ll introduce businesses to four
            proven revenue-generating and cost-saving programs. Each one is
            compliant, results-based, and non-disruptive.
          </p>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
          {JOIN_PROGRAMS.map((p, i) => (
            <Reveal key={p.slug} delay={(i % 2) * 0.1}>
              <article
                data-testid={JOIN.programCard(p.slug)}
                className="se-card h-full"
              >
                <div className="se-card__media">
                  <img src={p.image} alt={p.title} loading="lazy" />
                </div>
                <div className="se-card__body">
                  <span className="program-tag mb-4">{p.label}</span>
                  <h3
                    className="type-subheading mb-3"
                    style={{ fontSize: 24, letterSpacing: "-0.24px" }}
                  >
                    {p.title}
                  </h3>
                  <p className="type-body mb-6" style={{ flex: 1 }}>
                    {p.body}
                  </p>
                  <Link
                    to={`/programs/${p.slug}`}
                    className="link-arrow mt-auto"
                    style={{ alignSelf: "flex-start" }}
                  >
                    Learn more →
                  </Link>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
